module.exports = __webpack_public_path__ + "img/2_raon.5bf9aa12.jpg";